<template>

<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg171"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs175"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath185"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path183" /></clipPath></defs><g
     id="g177"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g179"><g
         id="g181"
         clip-path="url(#clipPath185)"><g
           id="g187"
           transform="translate(147.0942,448.1909)"><path
             d="m 0,0 94.36,52.312 c 9.049,5.016 20.043,5.016 29.092,0 l 233.954,-129.7 h -497 l 108.636,60.226"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path189" /></g><g
           id="g191"
           transform="translate(7.5,370.8027)"><path
             d="M 0,0 H 497 V -22.5 C 497,-34.927 486.927,-45 474.5,-45 H 22.5 C 10.074,-45 0,-34.927 0,-22.5 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path193" /></g><g
           id="g195"
           transform="translate(17.5,52.5)"><path
             d="m 0,0 h 477 c 5.522,0 10,-4.477 10,-10 v -25 c 0,-5.523 -4.478,-10 -10,-10 H 0 c -5.523,0 -10,4.477 -10,10 v 25 c 0,5.523 4.477,10 10,10 z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path197" /></g><g
           id="g199"
           transform="translate(334.4385,189.1514)"><path
             d="m 0,0 c 0,-43.32 -35.118,-78.438 -78.438,-78.438 -43.321,0 -78.438,35.118 -78.438,78.438 0,43.32 35.117,78.438 78.438,78.438 C -35.118,78.438 0,43.32 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path201" /></g><g
           id="g203"
           transform="translate(256,241.8247)"><path
             d="M 0,0 V -105.347"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path205" /></g><g
           id="g207"
           transform="translate(233.208,163.5103)"><path
             d="m 0,0 c 0,-8.497 6.123,-15.385 13.675,-15.385 h 18.234 c 7.553,0 13.675,6.888 13.675,15.385 v 10.257 c 0,8.497 -6.123,15.385 -13.676,15.385 L 13.675,25.641 C 6.123,25.641 0,32.529 0,41.026 v 10.256 c 0,8.497 6.123,15.385 13.675,15.385 h 18.234 c 7.553,0 13.675,-6.888 13.675,-15.385"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path209" /></g><g
           id="g211"
           transform="translate(283,432.0049)"><path
             d="m 0,0 c 0,-14.912 -12.088,-27 -27,-27 -14.912,0 -27,12.088 -27,27 0,14.912 12.088,27 27,27 C -12.088,27 0,14.912 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path213" /></g><g
           id="g215"
           transform="translate(474.5,52.5)"><path
             d="m 0,0 h -120.251 l 30,42.227 H -30 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path217" /></g><g
           id="g219"
           transform="translate(474.5,325.8027)"><path
             d="m 0,0 h -120.251 l 30,-42.228 H -30 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path221" /></g><g
           id="g223"
           transform="translate(384.249,190.2109)"><path
             d="M 0,0 V 93.364 H 60.251 V -95.484 L 0,-95.484 V -35"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path225" /></g><g
           id="g227"
           transform="translate(157.7515,52.5)"><path
             d="m 0,0 h -120.251 l 30,42.227 H -30 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path229" /></g><g
           id="g231"
           transform="translate(157.7515,325.8027)"><path
             d="m 0,0 h -120.251 l 30,-42.228 H -30 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path233" /></g><path
           d="M 127.751,94.727 H 67.5 v 188.848 h 60.251 z"
           style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path235" /></g></g></g></svg>
</template>
